import React from 'react';
import MediaItem from '../media/mediaItem';
import { optionsMap } from 'pro-gallery-lib';
const ThreeDItem = React.lazy(() => import(/* webpackChunkName: "ThreeDItem" */ './3dItem'));
export default function ThreeDItemWrapper(props) {
    const { options } = props;
    const playTrigger = options[optionsMap.behaviourParams.item.threeDimensionalScene.playTrigger];
    const showVideoPlayButton = options[optionsMap.behaviourParams.item.threeDimensionalScene.enablePlayButton];
    return (React.createElement(MediaItem, Object.assign({}, props, { MediaImplementation: ThreeDItem, playTrigger: playTrigger, placeholderExtraClasses: ['gallery-item-3d-placeholder'], enableImagePlaceholder: true, showPlayButton: showVideoPlayButton })));
}
//# sourceMappingURL=3dItemWrapper.js.map